"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _drawerStyleSettings = require("./drawerStyleSettings");

var _Portal = _interopRequireDefault(require("../Portal"));

var _utilities = require("../../utilities");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var DrawerModal = _styledComponents.default.div.attrs({
  "data-qa": "drawer-modal"
}).withConfig({
  displayName: "Drawer__DrawerModal",
  componentId: "rktr18-0"
})(["top:0;left:0;width:100%;height:100%;display:flex;z-index:1300;position:fixed;"]);

var DrawerBackdrop = _styledComponents.default.div.attrs({
  "data-qa": "drawer-backdrop"
}).withConfig({
  displayName: "Drawer__DrawerBackdrop",
  componentId: "rktr18-1"
})(["", " top:0;left:0;width:100%;height:100%;z-index:900;opacity:1;position:fixed;background-color:rgba(0,0,0,0.5);-webkit-tap-highlight-color:transparent;"], function (props) {
  return props.backgroundAnimation;
});

var DrawerWrapper = _styledComponents.default.div.attrs({
  "data-qa": "drawer-wrapper"
}).withConfig({
  displayName: "Drawer__DrawerWrapper",
  componentId: "rktr18-2"
})(["", " background-color:", ";top:0;flex:1 0 auto;height:100vh;display:flex;z-index:1200;outline:none;position:fixed;flex-direction:column;-webkit-overflow-scrolling:touch;transform:", ";", ";", ";"], function (props) {
  return props.drawerAnimation;
}, function (props) {
  return props.theme.carvana.gray.background;
}, function (props) {
  return props.isOpen ? 'translate3d(0, 0, 0)' : 'translate3d(100vw, 100vh, 0)';
}, function (props) {
  return props.drawerPositioning;
}, function (props) {
  return props.drawerStyles;
});

var Drawer = function (_PureComponent) {
  _inherits(Drawer, _PureComponent);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Drawer).call(this, props));
    _this.state = {
      isAnimating: false
    };
    _this.handleAnimationEnd = _this.handleAnimationEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Drawer, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var isOpen = this.props.isOpen;

      if (!nextProps.isOpen && isOpen) {
        this.setState({
          isAnimating: true
        });
      }
    }
  }, {
    key: "getDrawerAnimation",
    value: function getDrawerAnimation() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          anchor = _this$props.anchor;

      if (isOpen) {
        return _drawerStyleSettings.openDrawerKeyframes[anchor];
      }

      return _drawerStyleSettings.closeDrawerKeyframes[anchor];
    }
  }, {
    key: "getBackgroundAnimation",
    value: function getBackgroundAnimation() {
      var isOpen = this.props.isOpen;

      if (isOpen) {
        return _drawerStyleSettings.backgroundFadeIn;
      }

      return _drawerStyleSettings.backgroundFadeOut;
    }
  }, {
    key: "handleBackgroundScrolling",
    value: function handleBackgroundScrolling() {
      if (_utilities.IsServerSideRendering) {
        return;
      }

      var isOpen = this.props.isOpen;
      var isAnimating = this.state.isAnimating;

      if (isOpen || isAnimating) {
        document.body.style.overflow = 'hidden';
        return;
      }

      document.body.style.overflow = '';
    }
  }, {
    key: "handleAnimationEnd",
    value: function handleAnimationEnd() {
      this.setState({
        isAnimating: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchor = _this$props2.anchor,
          children = _this$props2.children,
          isOpen = _this$props2.isOpen,
          onClose = _this$props2.onClose,
          drawerStyles = _this$props2.drawerStyles;
      var isAnimating = this.state.isAnimating;
      this.handleBackgroundScrolling();

      if (!isOpen && !isAnimating) {
        return null;
      }

      var backgroundAnimation = (0, _styledComponents.css)(["animation:", " 400ms cubic-bezier(0.23,1,0.32,1);"], this.getBackgroundAnimation());
      var drawerAnimation = (0, _styledComponents.css)(["animation:", " 400ms cubic-bezier(0.23,1,0.32,1);"], this.getDrawerAnimation());
      return _react.default.createElement(_Portal.default, {
        "data-qa": "drawer"
      }, _react.default.createElement(DrawerModal, null, _react.default.createElement(DrawerBackdrop, {
        onClick: onClose,
        backgroundAnimation: backgroundAnimation
      }), _react.default.createElement(DrawerWrapper, {
        onAnimationEnd: this.handleAnimationEnd,
        drawerAnimation: drawerAnimation,
        isOpen: isOpen,
        drawerPositioning: _drawerStyleSettings.drawerPositions[anchor],
        drawerStyles: drawerStyles
      }, children)));
    }
  }]);

  return Drawer;
}(_react.PureComponent);

Drawer.defaultProps = {
  anchor: 'left',
  onClose: function onClose() {
    return null;
  },
  drawerStyles: {}
};
var _default = Drawer;
exports.default = _default;
module.exports = exports.default;